module.exports = __webpack_public_path__ + "media/images/gallery/11s-193c0d3fcde7b5ea77a50a347b60b370.jpg";